export default (state = {}, action) => {
  if (action.type === 'mudar_senha') {
    return { ...action };
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/componentes/modalSenhaReducer.js